<template>
<div class="sku_con">
	<el-table
	    :data="skus"
      @selection-change="handleSelectionChange"
	    border
	    style="width:95.2%;margin:0px auto;" size="medium" >
      <el-table-column
        type="selection"
        width="50">
      </el-table-column>
	    <el-table-column
	      prop="legalize_id"
	      label="id"
	      width="100">
	    </el-table-column>
	    <el-table-column
	      prop="account"
	      label="账号">
	    </el-table-column>
	    <el-table-column
	      prop="name"
	      label="用户名">
	    </el-table-column>
	    <el-table-column
	      prop="create_time"
	      label="认证时间">
	    </el-table-column>
	    <el-table-column
        label="认证类型">
        <template slot-scope="scope">
          {{scope.row.type===1?'实名认证':'资质认证'}}
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态">
        <template slot-scope="scope">
          <!-- {{scope.row.status===1?'正常':'冻结'}} -->
          <span v-if="scope.row.status==1">处理中</span>
          <span v-else-if="scope.row.status==2">通过审核</span>
          <span v-else-if="scope.row.status==3">驳回</span>
        </template>
      </el-table-column>
	    <el-table-column
	      label="认证信息">
	      <template slot-scope="scope">
	        <el-button
              size="mini"
              @click="fnPopShow(scope.row.legalize_id)">查看</el-button>
	      </template>
	    </el-table-column>
	    <el-table-column
	      label="操作">
	        <template slot-scope="scope">
	          <el-button
	            size="mini"
	            @click="fnAudit(scope.row.legalize_id, 2)">通过</el-button>
	          <el-button
	            size="mini"
	            type="danger"
	            @click="fnAudit(scope.row.legalize_id, 3)">驳回</el-button>
	        </template>
	    </el-table-column>
	 </el-table>

	 <el-dialog :title="title" :visible.sync="pop_show" append-to-body width="60%">
        <el-form :model="skuForm" :inline="true" status-icon ref="userForm" label-width="100px">
          <el-form-item label="名称:" prop="name">
            <el-input type="text" v-model="skuForm.name" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item v-if='skuForm.type==1' label="身份证号:" prop="user_profile.id_number">
            <el-input type="text" v-model="skuForm.user_profile.id_number" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item v-else label="身份证号:" prop="qualification.id_number">
            <el-input type="text" v-model="skuForm.qualification.id_number" autocomplete="off" size="small"></el-input>
          </el-form-item>

          <el-form-item v-if='skuForm.type==2' label="所在行业:" prop="qualification.industry">
            <el-input type="text" v-model="skuForm.qualification.industry" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item v-if='skuForm.type==2' label="公司/组织:" prop="qualification.company">
            <el-input type="text" v-model="skuForm.qualification.company" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item v-if='skuForm.type==2' label="岗位/职位:" prop="qualification.position">
            <el-input type="text" v-model="skuForm.qualification.position" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item v-if='skuForm.type==2' label="补充信息:" prop="qualification.add_info">
            <el-input type="text" v-model="skuForm.qualification.add_info" autocomplete="off" size="small"></el-input>
          </el-form-item>

          <el-form-item v-if='skuForm.type==1' label="身份证正面:" prop="user_profile.id_card_front">
            <el-input type="text" v-model="skuForm.user_profile.id_card_front" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item v-else label="身份证正面:" prop="qualification.id_card_front">
            <el-input type="text" v-model="skuForm.qualification.id_card_front" autocomplete="off" size="small"></el-input>
          </el-form-item>
<el-form-item v-if='skuForm.type==1' label="手持身份证:" prop="user_profile.id_card_handheld">
            <el-input type="text" v-model="skuForm.user_profile.id_card_handheld" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item v-else label="手持身份证:" prop="qualification.id_card_handheld">
            <el-input type="text" v-model="skuForm.qualification.id_card_handheld" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item v-if='skuForm.type==1' label="身份证背面:" prop="user_profile.id_card_back">
            <el-input type="text" v-model="skuForm.user_profile.id_card_back" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item v-else label="身份证背面:" prop="qualification.id_card_back">
            <el-input type="text" v-model="skuForm.qualification.id_card_back" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item v-if='skuForm.type==1' label="人脸识别信息:" prop="user_profile.id_card_front">
            <el-input type="text" v-model="skuForm.user_profile.id_card_front" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item v-else label="证明资料:" prop="qualification.qualification_img">
            <el-input type="text" v-model="skuForm.qualification.qualification_img" autocomplete="off" size="small"></el-input>
          </el-form-item>

          <br>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
          <el-form-item>
            <el-button @click="fnAudit(skuForm.legalize_id, 2)">通过</el-button>&emsp;&emsp;
            <el-button type="primary" @click="pop_show=false;pop_show2=true;">驳回</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>

      <el-dialog title="驳回原因" :visible.sync="pop_show2" append-to-body width="60%">
        <el-form :model="skuForm" :inline="true" status-icon ref="userForm" label-width="100px">
          <el-form-item label="驳回原因:" prop="caption">
            <el-input type="text" v-model="txt" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <br>
          <el-form-item>
            <el-button type="primary" @click="fnAudit(skuForm.legalize_id, 3)">提交</el-button>&emsp;&emsp;
            <el-button @click="pop_show2=false;pop_show=true;">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
</div>
</template>

<script>
import cons from '@/components/constant';

export default {
  name: 'SkuTable',
  props:['skus','selectedObj'],
  data () {
    return {
      pop_show:false,
      pop_show2:false,
      edit_id:'',
      title: '',
      txt: '',
      skuForm:{
        "legalize_id": '', // 申请记录id
        "account": "", // 账号
        "name": "",  // 姓名
        "create_time": "", // 申请认证时间
        "type": '', // 认证类型 1实名认证 2资质认证
        "status": '',
        user_profile: {},
        qualification: {}
      },
      category_list:[],
      goods_list:[],
      specs_list:[],
    }
  },
  methods:{
  	fnGetCategory(){
      let token = localStorage.token;
      this.axios.get(cons.apis + '/skus/categories/', {
        headers: {
          'Authorization': 'JWT ' + token
        },
        responseType: 'json',
      })
      .then(dat=>{
          this.category_list = dat.data;
      }).catch(err=>{
         console.log(err.response);
      });
    },
    fnGetGoods(){
      let token = localStorage.token;
      this.axios.get(cons.apis + '/goods/simple/', {
        headers: {
          'Authorization': 'JWT ' + token
        },
        responseType: 'json',
      })
      .then(dat=>{
          this.goods_list = dat.data;
      }).catch(err=>{
         console.log(err.response);
      });
    },
    fnGetSpecs(){
      let token = localStorage.token;
      this.axios.get(cons.apis + '/goods/'+ this.skuForm.goods_id + '/specs/', {
        headers: {
          'Authorization': 'JWT ' + token
        },
        responseType: 'json',
      })
      .then(dat=>{
          this.specs_list = dat.data;
      }).catch(err=>{
         console.log(err.response);
      });
    },
  	fnPopShow(id,gid){
      let token = localStorage.token;
      this.pop_show = true;
      this.edit_id = id;

  	  this.axios.get(cons.apis + '/v1_0/legalizes/'+ this.edit_id, {
        headers: {
          'Authorization': 'Bearer ' + token
        },
        responseType: 'json',
      })
      .then(dat=>{
        console.log(dat)
	        this.skuForm = dat.data.data;
          // alert(this.skuForm.type)
          this.title = this.skuForm.type==1?'实名认证':'身份认证'
      }).catch(err=>{
         console.log(err.response);
      });
  	},
  	submitForm(){
      let token = localStorage.token;
       var specs_sub_list = [];
       for(var k in this.skuForm.specs){
          specs_sub_list.push({'spec_id':k,'option_id':this.skuForm.specs[k]})
       }
       this.axios.put(cons.apis + '/skus/'+this.edit_id+'/',{
              "name":this.skuForm.name,
              "goods_id":this.skuForm.goods_id,
              "caption":this.skuForm.caption,
              "category_id": this.skuForm.category_id,
              "price": this.skuForm.price,
              "cost_price": this.skuForm.cost_price,
              "market_price": this.skuForm.market_price,
              "stock": this.skuForm.stock,
              "is_launched": this.skuForm.is_launched,
              "specs":specs_sub_list
            },{
            headers: {
              'Authorization': 'JWT ' + token
            },
            responseType: 'json'
        })
        .then(dat=>{
            console.log(dat);
              this.$message({
                type: 'success',
                message: '商品修改成功!'
              });
              this.pop_show = false;
              this.$emit('fnResetTable');
        }).catch(err=>{
           if(err.response.status==400){
               this.$message({
                  type:'info',
                  message:err.response.data.name[0]
              });
           }
        });
    },
    fnAudit(id, stu){
      let token = localStorage.token;
        this.edit_id = id;
        this.$confirm('是否确定改操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.axios.put(cons.apis + '/v1_0/legalizes',{
              "legalize_ids": [id], // 申请记录id列表
              "status": stu, // 2通过 3驳回
              "reject_reason": this.txt, // 驳回理由status=3时会用到，默认 “资料不通过，驳回”
            },
            {
              headers: {
                'Authorization': 'Bearer ' + token
              },
              responseType:'json'
          }).then(dat=>{
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
            this.pop_show = false;
            this.pop_show2 = false;
            this.$emit('fnResetTable');
          }).catch(err=>{
            if(err.response.status==404){
               this.$message({
                  type:'info',
                  message:'功能未找到！'
               });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    handleSelectionChange(val) {
      this.selectedObj.length = 0
      val.forEach(item => {
        this.selectedObj.push(item.legalize_id);
      })

    }
  },
  computed:{
     look_good_id(){
       return this.skuForm.goods_id
     }
  },
  watch:{
    look_good_id(newVal,oldVal){
       this.fnGetSpecs();
    }
  },
  mounted(){
    // this.fnGetCategory();
    // this.fnGetGoods();
  },
}
</script>
<style>
	.el-button+.el-button{
		margin-left:0px;
		margin-top:10px;
	}
</style>



// WEBPACK FOOTER //
// src/components/widget/UserAuditTable.vue